import { __awaiter, __generator } from "tslib";
export function registerComponents(vue) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            vue.component('Authorise', function () { return import('auth/components/oauth-authorise.vue'); });
            return [2 /*return*/];
        });
    });
}
